import React from "react";
import PasswordChangeContent from "../components/Admins/PasswordChangeContent";
import "./PasswordChange.css";

const PasswordChange = () => {
  return (
    <div className="password-change-page">
      <main className="password-change-main">
        <PasswordChangeContent />
      </main>
    </div>
  );
};

export default PasswordChange;
